import { keyAid, keyBid, keyCid, keyDid, keyId } from "@/atoms/common";

export function useInitialSetup() {
  const { isRtl } = useLanguage();

  useEffect(() => {
    // 处理位置参数
    if (keyId || keyAid || keyBid || keyCid || keyDid) {
      if (keyId) {
        LocalStorage.setItem("KEY_ID", keyId);
      } else {
        LocalStorage.removeItem("SELECT_CITY");
      }
    }
  }, []);
  useEffect(() => {
    // 处理RTL语言
    if (isRtl) {
      document.body.setAttribute("dir", "rtl");
    }
  }, [isRtl]);
}
